import { render, staticRenderFns } from "./trainingModulePageStart3.vue?vue&type=template&id=0e94bf88&scoped=true&"
import script from "./trainingModulePageStart3.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageStart3.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageStart3.vue?vue&type=style&index=0&id=0e94bf88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e94bf88",
  null
  
)

export default component.exports